<template>
  <div class="common-box" style="border-top:none;">
    <el-row class="row-one">
      <span class="row-one-title">我的理财顾问</span>
    </el-row>
    <div v-if="!followShow" class="dataNo">
      <img src="../../assets/images/advisor5.png" alt="">
      <div class="dataNo-con">
        <p>您还没有专属理财顾问！</p>
<!--        <a href="https://www.myfund.com/investmentAdviser.html" class="aColor" target="_blank">去搜索 > </a>-->
        <router-link :to="{name:'financialAdvisorList'}"><a class="aColor" target="_blank">去搜索 ></a></router-link>
      </div>
    </div>
    <!-- 有数据 -->
    <div v-else>
      <div class="advisor clearfix">
        <!-- header -->
        <div class="clearfix">
          <img class="fl" :src="adviserInfo.headImg" style="width: 90px;border-radius: 10px;">
          <div class="fl advisor-info">
            <p>姓<span style="margin:0 16px;"></span>名：<i>{{adviserInfo.AdviserName}}</i></p>
            <p>联系方式：<i>{{adviserInfo.Phone}}</i></p>
            <p>邮<span style="margin:0 16px;"></span>箱：<i>{{adviserInfo.Email}}</i></p>
            <p><a :href="'https://www.myfund.com/consultantDetails.html?id='+ adviserInfo.AdviserCode" class="aColor" style="font-size: 14px;" target="_blank">了解更多 》</a></p>
          </div>
          <div class="fl" style="width: 730px;text-align:center;">
            <el-input class="textarea-two" id="messageInfo" type="textarea" placeholder="请输入您要咨询的信息" v-model="textarea" :autosize="false" @blur="messageBlur"></el-input>
            <el-button type="simple" class="active margin-t15" style="border-radius: 10px;" @click="submitMessage(adviserInfo.AdviserCode)">提 交</el-button>
          </div>
        </div>
      </div>
      <div class="advisor-line"></div>
      <!-- table -->
      <div class="advisor-tit">
        <img src="../../assets/images/advisor1.png" alt="">
        <span>热销产品</span>
      </div>
      <!-- 表格 -->
      <el-table :data="adviserInfo.ProductList" class="table-single margin-t20" stripe border :cell-style="set_cell_style_one">
        <!-- <el-table-column prop="fundName" label="日期"></el-table-column> -->
        <el-table-column prop="FundName" label="基金名称"></el-table-column>
        <el-table-column prop="OneYearYield" label="近一年收益"></el-table-column>
        <el-table-column prop="ThisYearYield" label="今年以来收益"></el-table-column>
        <el-table-column prop="Characteristic" label="产品特点"></el-table-column>
        <el-table-column prop="Reason" label="推荐理由" width="350" align="left">
          <template slot-scope="scope">
            <pre style="text-overflow: clip;white-space: pre-wrap;">{{scope.row.Reason}}</pre>
          </template>
        </el-table-column>
        <el-table-column prop="AdviserCount" label="推荐人数"></el-table-column>
      </el-table>
      <div class="advisor-tit">
        <img src="../../assets/images/advisor2.png" alt="">
        <span>投资分享</span>
      </div>
      <!-- 表格 -->
      <el-table :data="shareLists" class="table-single margin-t20" stripe border :cell-style="set_cell_style">
        <el-table-column prop="AddedDate" label="日期" width="100"></el-table-column>
        <el-table-column style="text-align: left;" prop="Message" label="投资分享" align="left"></el-table-column>
      </el-table>
      <!-- 页码 -->
      <el-pagination class="pagination-single" @current-change="handleCurrentChange" @size-change="handleSizeChange" :current-page.sync="page" :page-size="pageNum" layout="prev, pager, next" :total="total" hide-on-single-page>
      </el-pagination>
    </div>
    <!-- 成功弹框 -->
    <el-dialog class="dialog-single-one" center :visible.sync="dialogVisable" :show-close="false">
      <img src="../../assets/images/2021_dg.png" alt="" width="60">
      <p class="dialog-single-one-p">您咨询的信息提交成功</p>
      <span slot="footer" class="dialog-footer">
        <el-button type="normal1" @click="dialogVisable = false;textarea = '';">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
const Base64 = require("js-base64").Base64;
import $ from 'jquery'
export default {
  data () {
    return {
      followShow: false,
      textarea: '',
      hotProductTableData: [],
      page: 1,
      pageNum: 3,
      total: 0,
      shareLists: [],
      adviserInfo: '',//顾问信息
      dialogVisable: false,
      adviserCode: '',
    }
  },
  mounted () {
    this.getAdviserRelation()
  },
  methods: {
    set_cell_style_one ({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 4) {
        return "text-align:left;";
      }
    },
    set_cell_style ({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 1) {
        return "text-align:left;";
      }
    },
    handleCurrentChange (newPage) {
      this.page = newPage
      this.getAdviserArchives(this.adviserCode)
    },
    handleSizeChange (newSize) {
      this.papageNumge = newSize
      this.getAdviserArchives(this.adviserCode)
    },
    // 理财顾问绑定
    getAdviserRelation () {
      this.$http.get(this.$apiPath.adviserRelation, {
        custno: this.$commonJs.getCookie('u_custno1')
      }).then(res => {
        // console.log(res);
        if (res.data.Result) {
          if (res.data.Data.Note != "申请中" && res.data.Data.Note != "未申请" && res.data.Data.Note != "结束服务" && res.data.Data.Note != "不通过") {
            this.followShow = true
            this.adviserCode = res.data.Data.Note
            this.getAdviserArchives(this.adviserCode)
            this.getAdviserShare(this.adviserCode)
          } else {
            this.followShow = false
          }
        }
      }).catch(err => { })
    },
    // 顾问档案
    getAdviserArchives (code) {
      this.$http.get(this.$apiPath.adviserArchives, {
        adviserCode: code
      }).then(res => {
        // console.log(res);
        if (res.data.Result) {
          this.adviserInfo = res.data.Data
          this.adviserInfo.headImg = this.adviserInfo.HeadPortrait
        }
      }).catch(err => { })
    },
    // 投资分享
    getAdviserShare (code) {
      this.$http.get(this.$apiPath.adviserShare, {
        adviserCode: code,
        page: this.page,
        pageNum: this.pageNum
      }).then(res => {
        // console.log(res);
        if (res.data.Result) {
          this.shareLists = res.data.Data.DataList
          this.total = res.data.recordCount
        }
      }).catch(err => { })
    },
    // 留言
    submitMessage (code) {
      if (this.textarea.trim() == "") {
        $("#messageInfo").css("border-color", '#ED0000');
      } else {
        $("#messageInfo").css("border-color", '#BFBFBF');
        this.$http.get(this.$apiPath.adviserMessage, {
          adviserCode: code,
          custno: this.$commonJs.getCookie('u_custno1'),
          userName: Base64.decode(this.$commonJs.getCookie('u_name1')),
          message: this.textarea,
          phone: this.$commonJs.getCookie('u_phone1'),
          myfpCustomer: '',
          returnVisit: ''
        }).then(res => {
          //   console.log(res);
          if (res.data.Result && res.data.Data.Note == "提交成功") {
            this.dialogVisable = true
          } else {
            this.$message.error('您咨询的信息提交失败')
            this.textarea = ''
          }
        }).catch(err => { })
      }
    },
    messageBlur () {
      if (this.textarea.trim() != "") {
        $("#messageInfo").css("border-color", '#BFBFBF');
      }
    }

  }
}
</script>

<style lang="less" scoped>
.advisor {
  margin: 30px 0 22px 28px;
  &-info {
    margin: 14px 40px 0;
    p {
      height: 30px;
      color: @color3;
      font-weight: 500;
      font-size: 16px;
    }
  }
  &-line {
    height: 2px;
    margin-top: 22px;
    border-top: 1px dashed @colorBF;
    border-bottom: 1px dashed @colorBF;
  }
  &-tit {
    margin-top: 30px;
    img {
      margin-top: -5px;
    }
    span {
      font-size: 16px;
      color: @color;
      font-weight: bold;
      margin-left: 10px;
    }
  }
}
.dataNo {
  box-sizing: border-box;
  text-align: center;
  padding-top: 100px;
  &-con p {
    font-weight: 500;
    font-size: 18px;
    color: @color3;
    margin: 10px 0;
  }
}
.tableLeft {
  .table-single .el-table__body-wrapper table tr td {
    text-align: left;
  }
}
</style>


